import { render, staticRenderFns } from "./DisplayForgottentAccnt.vue?vue&type=template&id=1b219e65&scoped=true"
import script from "./DisplayForgottentAccnt.vue?vue&type=script&lang=js"
export * from "./DisplayForgottentAccnt.vue?vue&type=script&lang=js"
import style0 from "./DisplayForgottentAccnt.vue?vue&type=style&index=0&id=1b219e65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b219e65",
  null
  
)

export default component.exports